var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAveragePasswordAgeInDaysForPrivilegedCs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 30,
    viewBox: "0 0 21 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "mp9zyounoa",
    d: "M0 0h20v14.184H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.61 .833)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "8z3b0825xb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mp9zyounoa"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.1 9.171 10.675.497c-.263-.663-1.212-.663-1.475 0L5.906 9.171 1.322 4.848c-.58-.53-1.502 0-1.291.769l1.87 7.639c.132.53.606.928 1.186.928H16.92c.553 0 1.053-.397 1.185-.928l1.871-7.64c.185-.769-.738-1.3-1.291-.769L14.1 9.171z",
    fill: "#AEB3B7",
    mask: "url(#8z3b0825xb)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.188 18.333H4.172a1.241 1.241 0 0 1-1.238-1.246c0-.69.553-1.247 1.238-1.247h12.99c.684 0 1.238.557 1.238 1.247 0 .69-.554 1.246-1.212 1.246z",
    fill: "#AEB3B7"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAveragePasswordAgeInDaysForPrivilegedCs);
export default __webpack_public_path__ + "static/media/average-password-age-in-days-for-privileged-cs.11af78e3.svg";
export { ForwardRef as ReactComponent };